module.exports = __webpack_public_path__ + "media/images/job-order-form-small-c41ffc601e31528ed32af3714189dd07.png";